import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from '../../components/funcs/BASES/withRouter'
import endPoints from '../../components/Consts/endPoints.json'

import { FaSave, FaShapes } from 'react-icons/fa'
import { FormLayout } from '../../components/features/Layouts'
import { InputOne } from '../../components/lib/input'
import { GridBlock } from '../../components/lib/grid'

import * as BeslenmeTypeActions from '../../redux/actions/BeslenmeType'

class BeslenmeTypeForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      onProcess: false,
      beslenmeType_id: '',
      beslenmeType_text: '',
      translated: {
        en: { beslenmeType_text: '' },
        tr: { beslenmeType_text: '' }
      }
    }
    this.releatedRoutes = endPoints.find(aa => aa.name == 'BeslenmeType')?.routes
  }

  componentDidMount() {
    try {
      var id = this.props.router.location.state.id
      this.setState({ beslenmeType_id: id }, () => {
        this.props.actions.GetOne(
          this.state.beslenmeType_id,
          () => { this.setState({ onProcess: true }) },
          () => { setTimeout(() => { this.setState({ onProcess: false }) }, 500) },
          data => {
            this.setState({
              beslenmeType_text: data?.beslenmeType_text || '',
              translated: data?.translated || {
                en: { beslenmeType_text: '' },
                tr: { beslenmeType_text: '' }
              }
            })
          },
          () => { }
        )
      })
    } catch (err) { }
  }

  submit = () => {
    var id = this.props.router?.location?.state?.id
    if (id == null || id == '') {
      this.props.actions.Create(
        this.state,
        () => { this.setState({ onProcess: true }) },
        () => { setTimeout(() => { this.setState({ onProcess: false }) }, 500) },
        () => { this.props.router.navigate(this.releatedRoutes.get) },
        () => { }
      )
    } else {
      this.props.actions.Update(
        this.state,
        () => { this.setState({ onProcess: true }) },
        () => { setTimeout(() => { this.setState({ onProcess: false }) }, 500) },
        () => { this.props.router.navigate(this.releatedRoutes.get) },
        () => { }
      )
    }
  }

  setVal = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  render() {
    return (
      <FormLayout
        naviIcon={<FaShapes size={30} color={'white'} />}
        recordIcon={<FaSave size={30} color={'white'} />}
        recordAction={this.submit}
        activeBack={() => {
          this.props.router.navigate(this.releatedRoutes?.get)
        }}
        loading={this.state.onProcess}
      >
        <GridBlock container={true} xs={12} sm={12} lg={12}>
          <GridBlock title={'Beslenme Yayın Yeri'} container={true} xs={12} sm={12} lg={12}>
            <InputOne
              color={'success'}
              variant='filled'
              margin='none'
              required
              fullWidth
              xs={12}
              sm={12}
              lg={12}
              id='beslenmeType_text'
              label='Yayın Yeri Adı'
              name='beslenmeType_text'
              value={this.state.beslenmeType_text}
              onChange={this.setVal}
              helperText='Beslenme yayın yeri adını giriniz (min 2 karakter)'
            />
          </GridBlock>

          <GridBlock title='Çeviriler (Translations)' container={true} xs={12} sm={12} lg={12}>
            <GridBlock title='İngilizce (EN)' container={true} xs={12} sm={12} lg={6}>
              <InputOne
                color={'success'}
                variant='filled'
                margin='none'
                fullWidth
                xs={12}
                sm={12}
                lg={12}
                id='translated_en_beslenmeType_text'
                label='Type Name (EN)'
                name='translated_en_beslenmeType_text'
                value={this.state.translated.en.beslenmeType_text}
                onChange={(e) => {
                  this.setState({
                    translated: {
                      ...this.state.translated,
                      en: { ...this.state.translated.en, beslenmeType_text: e.target.value }
                    }
                  })
                }}
                helperText='İngilizce yayın yeri adı'
              />
            </GridBlock>

            <GridBlock title='Türkçe (TR)' container={true} xs={12} sm={12} lg={6}>
              <InputOne
                color={'success'}
                variant='filled'
                margin='none'
                fullWidth
                xs={12}
                sm={12}
                lg={12}
                id='translated_tr_beslenmeType_text'
                label='Yayın Yeri Adı (TR)'
                name='translated_tr_beslenmeType_text'
                value={this.state.translated.tr.beslenmeType_text}
                onChange={(e) => {
                  this.setState({
                    translated: {
                      ...this.state.translated,
                      tr: { ...this.state.translated.tr, beslenmeType_text: e.target.value }
                    }
                  })
                }}
                helperText='Türkçe yayın yeri adı'
              />
            </GridBlock>
          </GridBlock>
        </GridBlock>
      </FormLayout>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      GetOne: bindActionCreators(BeslenmeTypeActions.GetOne, dispatch),
      Create: bindActionCreators(BeslenmeTypeActions.Create, dispatch),
      Update: bindActionCreators(BeslenmeTypeActions.Update, dispatch),
    }
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BeslenmeTypeForm)
)
